import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  ref: "uploadImage_contain"
};
const _hoisted_2 = {
  ref: "pixelArtList_contain"
};
const _hoisted_3 = {
  class: "product-name"
};
const _hoisted_4 = ["textContent"];
const _hoisted_5 = {
  ref: "loadingicon",
  class: "row mt-2 mb-2 text-center",
  id: "loading-icon",
  style: {
    "display": "none"
  }
};
const _hoisted_6 = {
  class: "col-12 text-center"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "loading-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_uploadImage = _resolveComponent("uploadImage");
  const _component_pixelArtList = _resolveComponent("pixelArtList");
  const _component_pixelArtDialog = _resolveComponent("pixelArtDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_uploadImage, {
    ref: "uploadImage",
    uploadUrl: $data.uploadUrl,
    createButImg: $data.createButImg,
    product_type: $data.product_type,
    onOnBeforeUpload: $options.onBeforeUpload,
    onOnUploadSucceed: $options.onUploadSucceed,
    onOnUploadFailed: $options.onUploadFailed,
    onStartcrop: $options.onStartcrop,
    onOnReceiveParticelResult: $options.onReceiveParticelResult,
    onOnReceiveParticelEnd: $options.onReceiveParticelEnd
  }, null, 8, ["uploadUrl", "createButImg", "product_type", "onOnBeforeUpload", "onOnUploadSucceed", "onOnUploadFailed", "onStartcrop", "onOnReceiveParticelResult", "onOnReceiveParticelEnd"])], 512), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentDataList, (o, j) => {
    return _openBlock(), _createElementBlock("div", {
      class: "product-contain",
      key: j
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
      textContent: _toDisplayString(o.product_show_name)
    }, null, 8, _hoisted_4)]), _createVNode(_component_pixelArtList, {
      refreshing: $data.uploading,
      dataList: o.product_images,
      product_type: o.product_type,
      showSelected: $data.currentSelectedState[j].selectedstate,
      onOnSelected: $options.onSelectedPixelArt
    }, null, 8, ["refreshing", "dataList", "product_type", "showSelected", "onOnSelected"])]);
  }), 128)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    class: "img-fluid",
    src: $data.loading_gif
  }, null, 8, _hoisted_7), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('messages.main_upload_wait_few_seconds')), 1)])], 512)], 512), _createVNode(_component_pixelArtDialog, {
    isdialogVisible: $data.isShowDialog,
    piexelImgInfo: $data.selectedEffectInfo,
    particelImg: $data.selectedParticleImg,
    onOnClose: $options.onCloseDialog,
    onOnClicklike: $options.onClicklike
  }, null, 8, ["isdialogVisible", "piexelImgInfo", "particelImg", "onOnClose", "onOnClicklike"])], 64);
}